/* eslint-disable */
var Cache = /*#__PURE__*/function () {
  function Cache() {
    this._root = null;
    this._store = new Map();
    this._root = null;
    this._store = new Map();
  }
  var _proto = Cache.prototype;
  _proto.empty = function empty() {
    return this._store.size === 0;
  };
  _proto.has = function has(key) {
    return this._store.has(key);
  };
  _proto.get = function get(key, defaultValue) {
    var res = this.has(key) ? this._store.get(key) : this.root();
    return typeof res === 'undefined' || res === null ? defaultValue : res;
  };
  _proto.add = function add(key, value) {
    if (this.empty()) {
      this._root = key;
    }
    this._store.set(key, value);
  };
  _proto.update = function update(key, value) {
    if (this.has(key)) {
      this._store.set(key, value);
    }
  };
  _proto.remove = function remove(key) {
    this._store["delete"](key);
    if (key === this._root) {
      var maps = this._store.keys();
      // 如果当前销毁的实例刚好是root，那么从map中取下一个加入的节点当作root
      var nextkey = maps.next().value;
      this._root = nextkey;
    }
  };
  _proto.clear = function clear() {
    this._store.clear();
  };
  _proto.root = function root() {
    return this._store.get(this._root);
  };
  return Cache;
}();
export default Cache;